import React, {useContext, useState} from "react";
import {useHistory} from "react-router-dom";
import {RoutePath} from "../../router/routePath";
import GroupList from "./groupList";
import Button from "../../components/button/button";
import Tab from "../../components/tab/tab";
import {ProviderContext} from "../providerContext";
import PatientList from "./patientList";
import {PromptContext} from "../promptContext";
import {MTips} from "../../util/constants";

enum GroupType {
    myCustomGroup,
    allPatients
}

function Patients() {
    const [groupType, setGroupType] = useState<GroupType>(GroupType.myCustomGroup)
    const history = useHistory()
    const provider = useContext(ProviderContext)
    const {showInfo} = useContext(PromptContext)

    const $title = (
        <p className={"text-gary-1 text-2xl font-bold"}>Patient Group</p>
    )

    const $tab = (
        <div className={"mt-2"}>
            <Tab selectedIndex={groupType === GroupType.myCustomGroup ? 0 : 1} data={["My Custom Group", "All Patients"]} onChange={(idx) => {
                if (idx === 0) {
                    setGroupType(GroupType.myCustomGroup)
                } else {
                    setGroupType(GroupType.allPatients)
                }
            }}/>
        </div>
    )

    const onCreateNewGroup = () => {
        if (provider.employeeRole === 1) {
            history.push(RoutePath.newGroup)
        } else {
            showInfo(MTips.roleErrorMsg)
        }
    }

    const $newGroup = (
        <Button onClick={onCreateNewGroup} >
            <div className={"flex items-center space-x-2"}>
                <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13 7H8.5V2.5C8.5 1.94781 8.05219 1.5 7.5 1.5H6.5C5.94781 1.5 5.5 1.94781 5.5 2.5V7H1C0.447812 7 0 7.44781 0 8V9C0 9.55219 0.447812 10 1 10H5.5V14.5C5.5 15.0522 5.94781 15.5 6.5 15.5H7.5C8.05219 15.5 8.5 15.0522 8.5 14.5V10H13C13.5522 10 14 9.55219 14 9V8C14 7.44781 13.5522 7 13 7Z" fill="white"/>
                </svg>
                <p>New Group</p>
            </div>
        </Button>
    )

    const $header = (
        <div className={"flex flex-row items-center justify-between"}>
            <div>
                {$title}
                {$tab}
            </div>
            {$newGroup}
        </div>
    )

    return (
        <div className={"w-full px-10 py-6"}>
            {$header}
            {groupType === GroupType.myCustomGroup ? <GroupList/> : <PatientList/>}
        </div>
    )
}

export default Patients
